import { t } from "ttag";

export const globalShortcuts = {
  "create-question": {
    name: t`Create a question`,
    shortcut: ["q"],
    shortcutGroup: "global",
  },
  "create-native-query": {
    name: t`Create a native query`,
    shortcut: ["n"],
    shortcutGroup: "global",
  },
  "create-dashboard": {
    name: t`Create a dashboard`,
    shortcut: ["d"],
    shortcutGroup: "global",
  },
  "create-collection": {
    name: t`Create a collection`,
    shortcut: ["c"],
    shortcutGroup: "global",
  },
  "create-model": {
    name: t`Create a model`,
    shortcut: ["m"],
    shortcutGroup: "global",
  },
  "create-metric": {
    name: t`Create a metric`,
    shortcut: ["k"],
    shortcutGroup: "global",
  },
  "browse-database": {
    name: t`Browse databases`,
    shortcut: ["b d"],
    shortcutGroup: "global",
  },
  "browse-model": {
    name: t`Browse models`,
    shortcut: ["b m"],
    shortcutGroup: "global",
  },
  "browse-metric": {
    name: t`Browse metrics`,
    shortcut: ["b k"],
    shortcutGroup: "global",
  },

  "report-issue": {
    name: t`Report an issue`,
    shortcut: ["$mod+f1"],
    shortcutGroup: "global",
  },
  "shortcuts-modal": {
    name: t`Toggle Shortcuts Modal`,
    shortcut: ["?"],
    shortcutGroup: "global",
  },

  "navigate-trash": {
    name: t`Open trash`,
    shortcut: ["t"],
    shortcutGroup: "global",
  },
  "navigate-personal-collection": {
    name: t`Open personal collection`,
    shortcut: ["p"],
    shortcutGroup: "global",
  },

  "toggle-navbar": {
    name: t`Toggle sidebar`,
    shortcut: ["["],
    shortcutGroup: "global",
  },
  "navigate-admin-settings": {
    name: t`Go to admin`,
    shortcut: ["g a"],
    shortcutGroup: "global",
  },

  "navigate-user-settings": {
    name: t`Go to user settings`,
    shortcut: ["g u"],
    shortcutGroup: "global",
  },
};
